<template>
  <div class="h-full">
    <div class="h-full flex flex-col gap-y-2 lg:gap-y-4">
      <div>
        <div class="flex justify-between items-center flex-wrap gap-2 relative lg:gap-3">
          <div class="w-full flex justify-center lg:absolute">
            <GrmSearch :value="testbankExamListFilter.searchText"
                       class="w-full lg:w-60"
                       ref="search"
                       @input="(value) => SET_TESTBANK_EXAM_LIST_FILTER({ searchText: value })"
                       @clear="() => {
                         SET_TESTBANK_EXAM_LIST_FILTER({ searchText: '' });
                         $refs.search.$refs.search.focus();
                       }"
            />
          </div>
          <ul class="flex items-center gap-x-2">
            <li>
              <GrmSimpleSelect
                :value="testbankExamListFilter.size"
                :options="[
                  { value: 10, title: $t('common.table.count.ten') },
                  { value: 20, title: $t('common.table.count.twenty') },
                  { value: 30, title: $t('common.table.count.thirty') },
                  { value: 40, title: $t('common.table.count.forty') },
                  { value: 50, title: $t('common.table.count.fifty') },
                ]"
                @input="(value) => SET_TESTBANK_EXAM_LIST_FILTER({ size: value })"
              />
            </li>
          </ul>
          <div class="flex items-center gap-x-1 relative">
            <GrmBtn color="gray" @click="SET_VIEW('testbank__list')">{{ $t("testBank.goBack") }}</GrmBtn>
            <GrmBtn @click="onCreateTestbank">{{ $t("testBank.regPaper") }}</GrmBtn>
          </div>
        </div>
      </div>
      <div class="min-h-0 flex-1">
        <RoomTestbankExamTable />
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {debounce} from "lodash";

import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import GrmSearch from "@/components/Common/search/GrmSearch.vue";
import GrmSimpleSelect from '@/components/Common/select/GrmSimpleSelect';
import RoomTestbankExamTable from "@/components/Room/Testbank/Exam/RoomTestbankExamTable.vue";

export default {
  name: 'RoomTestbankExamList',
  components: {
    GrmBtn,
    GrmSearch,
    GrmSimpleSelect,
    RoomTestbankExamTable,
  },
  computed: {
    ...mapState('testbank', [
      'testbankExamListFilter',
    ]),
  },
  watch: {
    testbankExamListFilter: {
      handler() {
        this._getTestbankExamList();
      },
      deep: true,
    }
  },
  methods: {
    ...mapActions('testbank', [
      'getTestbankExamList',
    ]),
    ...mapMutations('testbank', [
      'SET_VIEW',
      'SET_TESTBANK',
      'DELETE_TESTBANK',
      'SET_TESTBANK_EXAM',
      'SET_TESTBANK_EXAM_LIST_FILTER',
    ]),

    _getTestbankExamList: debounce(function () {
      this.getTestbankExamList();
    }, 200, {
      leading: false,
      trailing: true,
    }),
    onCreateTestbank() {
      this.SET_TESTBANK_EXAM();
      this.SET_VIEW('testbank__exam_create');
    },
  }
}
</script>